import apiClient from '@u/apiClient'
import GetElectronicSignatureListController from '@/wayfinder/actions/App/Http/Controllers/ElectronicSignature/GetElectronicSignatureListController'
import CountElectronicSignatureByStatusController from '@/wayfinder/actions/App/Http/Controllers/ElectronicSignature/CountElectronicSignatureByStatusController'
import GetElectronicSignatureByIdController from '@/wayfinder/actions/App/Http/Controllers/ElectronicSignature/GetElectronicSignatureByIdController'
import DownloadAuditDocumentElectronicSignatureController from '@/wayfinder/actions/App/Http/Controllers/ElectronicSignature/DownloadAuditDocumentElectronicSignatureController'
import ElectronicSignatureDownloadYousignDocumentController from '@/wayfinder/actions/App/Http/Controllers/ElectronicSignature/ElectronicSignatureDownloadYousignDocumentController'
import DeleteMediaFromElectronicSignatureController from '@/wayfinder/actions/App/Http/Controllers/ElectronicSignature/DeleteMediaFromElectronicSignatureController'
import DeleteElectronicSignatureController from '@/wayfinder/actions/App/Http/Controllers/ElectronicSignature/DeleteElectronicSignatureController'
import UpdateSignerPersonForSignature from '@/wayfinder/actions/App/Http/Controllers/ElectronicSignature/UpdateSignerPersonForSignature'
import UndoDeleteMediaController from '@/wayfinder/actions/App/Http/Controllers/ElectronicSignature/UndoDeleteMediaController'
import AddPDFToEnvelopeController from '@/wayfinder/actions/App/Http/Controllers/ElectronicSignature/AddPDFToEnvelopeController'
import SendElectronicSignatureToYouSign from '@/wayfinder/actions/App/Http/Controllers/ElectronicSignature/SendElectronicSignatureToYouSign'
import SyncElectronicSignatureToYouSign from '@/wayfinder/actions/App/Http/Controllers/ElectronicSignature/SyncElectronicSignatureToYouSign'
import AddSignersToYouSign from '@/wayfinder/actions/App/Http/Controllers/ElectronicSignature/AddSignersToYouSign'
import GetOngoingElectronicSignature from '@/wayfinder/actions/App/Http/Controllers/ElectronicSignature/GetOngoingElectronicSignature'
import StoreSignedElectronicSignatures from '@/wayfinder/actions/App/Http/Controllers/ElectronicSignature/StoreSignedElectronicSignatures'

export default {
  // region fetch
  async fetchElectronicSignature({ commit }, payload) {
    return apiClient
      .route(GetElectronicSignatureListController.get(), {
        params: payload
      })
      .then((response) => response.data)
  },
  async fetchCountElectronicSignature({ commit }, payload) {
    return apiClient
      .route(CountElectronicSignatureByStatusController.get())
      .then((response) => response.data)
  },
  fetchElectronicSignatureById({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          GetElectronicSignatureByIdController.get({
            electronicSignature: payload.id
          })
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  downloadYouSignAudit({ commit }, { electronicSignature, signer }) {
    return apiClient
      .route(
        DownloadAuditDocumentElectronicSignatureController.post({
          electronicSignature,
          signer
        })
      )
      .then((res) => res.data)
  },
  downloadYousignDocumentByElectronicSignatureId({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          ElectronicSignatureDownloadYousignDocumentController.get({
            electronicSignature: payload.id,
            document_id: payload.document_id
          })
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  // endregion
  // region store
  // endregion
  // region update
  // endregion
  //region delete
  deleteMediaFromEnvelope({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          DeleteMediaFromElectronicSignatureController.delete({
            electronicSignature: payload.electronic_signature_id,
            media: payload.media_id
          })
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  deleteElectronicSignature({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          DeleteElectronicSignatureController.delete({
            electronicSignature: payload.electronic_signature_id
          })
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  updateSignerPerson({ commit }, { signer_id, model_type, model_id }) {
    return apiClient
      .route(
        UpdateSignerPersonForSignature.post({ electronicSigner: signer_id }),
        {
          data: {
            model_type,
            model_id
          }
        }
      )
      .then((response) => response.data)
  },
  restoreMediaFromEnvelope({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          UndoDeleteMediaController.get({
            electronicSignature: payload.electronic_signature_id,
            media: payload.media_id
          })
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  //endregion
  addPdfToEnvelope({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(AddPDFToEnvelopeController.post(), payload.params)
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  sendToYouSign({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          SendElectronicSignatureToYouSign.post({
            electronicSignature: payload.electronic_signature_id
          }),
          payload.params
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  syncToYouSign({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          SyncElectronicSignatureToYouSign.post({
            electronicSignature: payload.electronic_signature_id
          }),
          payload.params
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  addSignersToYouSign({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          AddSignersToYouSign.post({
            electronicSignature: payload.electronic_signature_id
          }),
          payload.params
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  getOngoingElectronicSignature({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          GetOngoingElectronicSignature.get({
            electronicSignature: payload.electronic_signature_id
          }),
          payload.params
        )
        .then((response) => {
          console.log(response)
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  storeSignedElectronicSignature({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          StoreSignedElectronicSignatures.get({
            electronicSignature: payload.electronic_signature_id,
            media_id: payload.media_id
          }),
          payload.params
        )
        .then((response) => {
          console.log(response)
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  }
}
